/* Landing «Auditoría de seguridad PrestaShop»: formulario de descarga contra tools.lineagrafica.es/api/auditoria.
   Email y casilla comercial opcionales; Turnstile solo si la API da sitekey y solo se exige si hay email. */
(function () {
  var root = document.querySelector('[data-lga]');
  if (!root) return;
  var API = root.getAttribute('data-api') || 'https://tools.lineagrafica.es';
  var ZIP = API + '/api/auditoria/lgsecurityaudit.zip';
  var locale = root.getAttribute('data-lang') || 'es';
  var lang = locale.slice(0, 2); // a la API: es, en, fr, de, it, pl, pt, ro
  var I = window.LGA_I18N || {};
  var T = I[locale] || I[lang] || I.es || {}; // textos generados desde tema-auditoria/i18n/*.json
  var form = root.querySelector('[data-lga-form]');
  var out = root.querySelector('[data-lga-out]');
  var btn = root.querySelector('[data-lga-submit]');
  var boxCap = root.querySelector('[data-lga-captcha]');
  var sitekey = '', widget = null, tsToken = '';

  // Mensaje de vuelta del enlace de confirmación (?confirmado=1 / 0).
  var q = new URLSearchParams(location.search).get('confirmado');
  var box = root.querySelector('[data-lga-confirmado]');
  if (box && (q === '1' || q === '0')) {
    box.hidden = false;
    box.className += q === '1' ? ' lga__msg--ok' : ' lga__msg--err';
    box.textContent = q === '1' ? T.confirmed_ok : T.confirmed_ko;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  var ERR = {};
  ['email', 'mx', 'disposable', 'captcha', 'rate', 'body', 'unavailable', 'slow', 'busy'].forEach(function (k) { ERR[k] = T['err_' + k]; });

  function msg(t, err, html) {
    out.className = 'lga__out' + (err ? ' lga__out--err' : '');
    if (html) out.innerHTML = t; else out.textContent = t;
  }
  function respaldo() { return ' <a href="' + ZIP + '">' + T.direct + '</a>.'; }
  function bajar(url) {
    var a = document.createElement('a');
    a.href = url || ZIP; a.rel = 'noopener'; document.body.appendChild(a); a.click(); a.remove();
  }

  // Turnstile: obligatorio en cuanto la API tenga claves (se pinta al cargar). Sin claves, la API da un token firmado
  // con la hora (form_token): el envío con email no vale hasta pasados unos segundos desde que se cargó la página.
  var formToken = '';
  fetch(API + '/api/auditoria/config.json', { credentials: 'omit', cache: 'no-store' }).then(function (r) { return r.json(); })
    .then(function (c) { sitekey = (c && c.turnstile) || ''; formToken = (c && c.form_token) || ''; if (sitekey) cargarCaptcha(); }).catch(function () {});
  function cargarCaptcha() {
    if (!sitekey || widget !== null || !boxCap) return;
    widget = false;
    window.lgaTs = function () {
      boxCap.hidden = false;
      widget = window.turnstile.render(boxCap, { sitekey: sitekey, language: lang, callback: function (t) { tsToken = t; }, 'expired-callback': function () { tsToken = ''; } });
    };
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=lgaTs';
    s.async = true; document.head.appendChild(s);
  }
  form.email.addEventListener('input', function () { if (form.email.value.trim()) cargarCaptcha(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = form.email.value.trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg(ERR.email, true); return; }
    if (sitekey && !tsToken) { cargarCaptcha(); msg(ERR.captcha, true); return; }
    btn.disabled = true; msg(T.preparing);
    fetch(API + '/api/auditoria/descarga', {
      method: 'POST', credentials: 'omit', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email: email, marketing: !!form.marketing.checked, lang: lang, website: form.website.value, turnstile: tsToken, form_token: formToken })
    }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'body' }; }); })
      .then(function (j) {
        if (j && j.ok) {
          bajar(j.url);
          msg((j.pending ? T.started_pending : T.started) + respaldo(), false, true);
          return;
        }
        var err = (j && j.error) || 'body';
        if (err === 'captcha' && window.turnstile && widget) { window.turnstile.reset(widget); tsToken = ''; }
        msg((ERR[err] || ERR.body) + (err === 'unavailable' || err === 'slow' ? '' : respaldo()), true, true);
      })
      .catch(function () { msg(T.err_network + respaldo(), true, true); })
      .then(function () { btn.disabled = false; });
  });
})();
